import { forwardRef } from 'react';
import { styled, CircularProgress } from '@mui/material';
import { LoadingButtonProps, LoadingButton } from '@mui/lab';

export const DashboardVariantV2GiverContentInPreparationTabDataTableIconButton =
  styled(
    forwardRef<HTMLButtonElement, LoadingButtonProps>(
      function DashboardVariantV2GiverContentInPreparationTabDataTableIconButton(
        inProps,
        ref,
      ) {
        return (
          <LoadingButton
            {...inProps}
            ref={ref}
            loadingIndicator={
              <CircularProgress color="inherit" size="inherit" />
            }
            loadingPosition="center"
          />
        );
      },
    ),
  )(({ theme, size }) => ({
    fontSize: theme.typography.pxToRem(20),
    minWidth: 0,
    padding: '5px 4px',

    ...(size === 'small' && {
      padding: '3px 2px',
    }),

    ...(size === 'large' && {
      padding: '12px 10px',
    }),

    '& svg': {
      width: '1em',
      height: '1em',
      fontSize: 'inherit',
    },
  }));
